import { react } from "uikit";
import { Dispatch } from "react";

import { PaymentCurrency } from "../../../../../../../../services/PaymentSystem";

import CybersourcePaymentsCurrency from ".";

interface Context {
	value: CybersourcePaymentsCurrency.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid =
			this.context?.value.cybersourceCurrency !== PaymentCurrency.NULL;

		if (!isValid) {
			this.context?.setError(true);
			return isValid;
		}
		this.context?.setError(false);
		return isValid;
	}
}
